import { Link } from 'react-router-dom';
import { useUserStore, useAuthStore } from '../stores/movieStore';

const FavoritePage = () => {
  const { favorites, removeFavorite } = useUserStore();
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-white mb-4">请先登录</h2>
          <Link to="/login" className="px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl">去登录</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-white">我的收藏</h1>
            <p className="text-gray-400 mt-2">共 {favorites.length} 部收藏的影视作品</p>
          </div>
        </div>

        {favorites.length === 0 ? (
          <div className="text-center py-20">
            <div className="w-32 h-32 bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-6xl">❤️</span>
            </div>
            <h2 className="text-xl font-bold text-white mb-4">还没有收藏</h2>
            <p className="text-gray-400 mb-8">去发现你喜欢的影视作品吧</p>
            <Link to="/" className="px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl hover:from-blue-600 hover:to-purple-700 transition-all">探索首页</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-6">
            {favorites.map((item) => (
              <div key={`${item.source}:${item.videoId}`} className="group relative">
                <Link to={`/movie/${item.videoId}`}>
                  <div className="relative overflow-hidden rounded-2xl bg-slate-800/50 card-hover">
                    <div className="aspect-[2/3] overflow-hidden">
                      <img src={item.poster} alt={item.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" loading="lazy" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                    </div>
                    <div className="absolute top-3 right-3">
                      <div className="flex items-center space-x-1 px-2 py-1 bg-black/60 backdrop-blur-sm rounded-lg">
                        <svg className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                        <span className="text-sm font-semibold text-yellow-400">{item.rating.toFixed(1)}</span>
                      </div>
                    </div>
                  </div>
                </Link>
                <div className="mt-3 px-1">
                  <Link to={`/movie/${item.videoId}`}>
                    <h3 className="text-white font-medium text-sm line-clamp-1 group-hover:text-blue-400 transition-colors">{item.title}</h3>
                  </Link>
                  <div className="flex items-center justify-between mt-2">
                    <span className="text-gray-400 text-xs">{item.year}</span>
                    <button onClick={() => removeFavorite(item.videoId, item.source)} className="text-red-400 hover:text-red-300 transition-colors" title="取消收藏">
                      <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                        <path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FavoritePage;
